/**
 * Arabic Financial Number to Words
 */
const units = ['', 'واحد', 'اثنان', 'ثلاثة', 'أربعة', 'خمسة', 'ستة', 'سبعة', 'ثمانية', 'تسعة'];
const tens = ['', 'عشرة', 'عشرون', 'ثلاثون', 'أربعون', 'خمسون', 'ستون', 'سبعون', 'ثمانون', 'تسعون'];
const hundreds = ['', 'مئة', 'مئتان', 'ثلاثمئة', 'أربعمئة', 'خمسمئة', 'ستمئة', 'سبعمئة', 'ثمانمئة', 'تسمئة'];

function convertThreeDigits(n) {
  if (n === 0) return '';
  let res = '';
  const h = Math.floor(n / 100);
  const t = Math.floor((n % 100) / 10);
  const u = n % 10;

  if (h > 0) res += hundreds[h];
  
  if (t === 0 && u > 0) {
    if (res !== '') res += ' و ';
    res += units[u];
  } else if (t === 1) {
    if (res !== '') res += ' و ';
    if (u === 0) res += 'عشرة';
    else if (u === 1) res += 'أحد عشر';
    else if (u === 2) res += 'اثنا عشر';
    else res += units[u] + ' عشر';
  } else if (t > 1) {
    if (res !== '') res += ' و ';
    if (u > 0) res += units[u] + ' و ' + tens[t];
    else res += tens[t];
  }
  return res;
}

export const convertToArabic = (num) => {
  if (num === 0) return 'صفر';
  const isNegative = num < 0;
  num = Math.abs(num);
  const intPart = Math.floor(num);
  const decPart = Math.round((num - intPart) * 100);
  
  let parts = [];
  let temp = intPart;

  if (temp >= 1000000) {
    const m = Math.floor(temp / 1000000);
    parts.push(convertThreeDigits(m) + ' مليون');
    temp %= 1000000;
  }
  if (temp >= 1000) {
    const k = Math.floor(temp / 1000);
    parts.push(convertThreeDigits(k) + ' ألف');
    temp %= 1000;
  }
  if (temp > 0 || parts.length === 0) {
    parts.push(convertThreeDigits(temp));
  }
  
  let res = (isNegative ? 'سالب ' : '') + parts.join(' و ');
  if (decPart > 0) res += ' فاصلة ' + convertThreeDigits(decPart);
  return res;
};